module.exports = __webpack_public_path__ + "static/img/yst_benefit_bg.91d79eb0.png";